import React,{useState} from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import Menubar from './Menubar'; 
import Footer from './Footer'; 
import Logo from './websiteLogo.png';
import Input from './Input';

function Nav(){
   const[disp,updisp]=useState(false);
 
   function closeMenu(){
    updisp(false)
   }

    return(
        <>
             <Menubar dispa={disp} close={closeMenu} />
     <nav className='navv'>
         <ul  className='ull'>
             <li className='lii'>
             <MenuIcon onClick={()=>updisp(true)} className='buttt'/>

             </li>
             <li className='lii'>
                 <NavLink
                  style={({isActive})=>{
                      return{
                          color:isActive?'#005dffdb':'black'
                      }
                  }}
                  className='navi homebutt' to='/'> <HomeIcon  /></NavLink>
             </li>
             
             <li className='lii'>
            <img src={Logo} className='websiteLogo'/>

             </li>
             <li className='lii'>
             <Input  inputname='inputsearchnav' />
             </li>
            
            
             
         </ul>
     </nav>
     <Outlet/>
     <Footer />
</>
    )
}

export default Nav;